import type {
  TlfArsListingReadDto,
  TlfArsTableReadDto,
  TlfFigureReadDto,
  TlfListingReadDto,
  TlfTableReadDto,
  TlfV1FigureReadDto,
} from "functions/api/tlfItem/TlfItemReadDto";

type PermittedVariantUpdateableKey =
  | "analysisSetId"
  | "body"
  | "domain"
  | "footnotes"
  | "outputName"
  | "outputType"
  | "pageBy"
  | "programName"
  | "programmerNotes"
  | "standardsNotes"
  | "suffix"
  | "titles";
type TlfDtoKey =
  | keyof TlfArsListingReadDto
  | keyof TlfArsTableReadDto
  | keyof TlfFigureReadDto
  | keyof TlfListingReadDto
  | keyof TlfTableReadDto
  | keyof TlfV1FigureReadDto;
type VariantUpdateableKey = {
  [Key in PermittedVariantUpdateableKey]: Key extends TlfDtoKey ? Key : never;
}[PermittedVariantUpdateableKey];

/**
 * The TLF item properties that a variant is permitted to override.
 */
export const VARIANT_UPDATEABLE_KEYS: VariantUpdateableKey[] = [
  "analysisSetId",
  "body",
  "domain",
  "footnotes",
  "outputName",
  "outputType",
  "pageBy",
  "programName",
  "programmerNotes",
  "standardsNotes",
  "suffix",
  "titles",
];
